import styled from "styled-components";

const Button = styled.button`
  padding: ${(props) => props.padding || "5px"};
  background: ${(props) => props.bg || "var(--navbar-bg)"};
  text-align: center;
  width: ${(props) => props.width || "50px"};
  max-width: ${(props) => props.maxWidth || "100%"};
  opacity: ${(props) => props.opacity || "1"};
  outline: none;
  border-radius: ${(props) => props.radius || "40px"};
  font-size: ${(props) => props.fontSize || "16.51px"};
  color: ${(props) => props.color || "white"};
  font-weight: ${(props) => props.fontWeight || "lighter"};
  outline: none;
  border: none;
`;

const PaginateButton = styled(Button)`
  border: 1px solid var(--borderUniversal);
  color: var(--pickSize);
`;

const FixedDiv = styled.div`
width: 100vw;
overflow: scroll;
display: flex;
flex-direction: column;
justify-content: center;
transform: ${props => props.visible ? 'translateX(0)' : 'translateX(-100%)'};
background-color: #f5f5f5;
height: 100vh;
top: 0;
left: 0;
right: 0;
bottom: 0;
transition: all 0.4s linear;
position: fixed;
z-index: 1;
padding: 10px;
h5 {
  color: var(--productTitle);
  font-weight: lighter;
  font-size: 20px;
  padding-top: 100px;
  text-align: center;
}

@media screen and (max-width: 360px) {
  h5 {
    margin-top: 200px;
  }
}

`

 const FiltersWrapper = styled.div`
.filters-container {
  display: block;
}

@media screen and (max-width: 550px) {
  .search {
    width: 250px;
  }
  .search {
  background: #ffff;
}
}
`

const Carousel = styled.span`
.bottom-images {
  width: 80px;
  height: 80px;
  margin: 10px 0px 0px 10px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: var(--mainTransition);
}
.bottom-border {
  border-bottom: 2px solid #ffcd00;
}
`



export { Button, PaginateButton, FixedDiv, FiltersWrapper, Carousel };
